module.exports = __webpack_public_path__ + "static/media/bg6.f9122009.png";